const rootMenuDropdownAndDropdownMenuDefaultStyleProperties = {
    'dropdown-align': 'start',
    'dropdown-anchor': 'screen',
    'dropdown-space-above': '0px',
    'dropdown-horizontal-margin': '0px',
    'dropdown-menu-container-vertical-padding': '0px',
    'dropdown-menu-container-horizontal-padding': '0px',
    'dropdown-menu-item-vertical-spacing': '0px',
    'dropdown-menu-item-horizontal-spacing': '0px',
    'dropdown-menu-sub-items-vertical-spacing-before': '0px',
    'dropdown-menu-sub-items-vertical-spacing-between': '0px',
    'dropdown-menu-item-vertical-padding': '0px',
    'dropdown-menu-item-horizontal-padding': '0px',
    'dropdown-menu-sub-item-vertical-padding': '0px',
    'dropdown-menu-sub-item-horizontal-padding': '0px',
    'dropdown-menu-columns-number': '2',
    'dropdown-menu-align': 'start',
    'dropdown-menu-item-align': 'inherit',
    'dropdown-menu-sub-item-align': 'inherit'
}

module.exports = {
    rootMenuDropdownAndDropdownMenuDefaultStyleProperties
}
